import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "gql/apollo";
import {
	ImpactAgentFeedbackStatus,
	impactAgentFeedbackFieldsFragmentDoc,
} from "gql/apollo/graphql";
import { useHasFeature } from "ui-library/HasFeature";

export const ListImpactAgentFeedbacks = graphql(/* GraphQL */ `
	query ListImpactAgentFeedbacks($params: ListImpactAgentFeedbacksParams!) {
		listImpactAgentFeedbacks(params: $params) {
			...impactAgentFeedbackFields
		}
	}
`);

interface Params {
	impactAgentId: string;
	feedbackStatus: ImpactAgentFeedbackStatus;
}

export const useListImpactAgentFeedbacks = ({
	impactAgentId,
	feedbackStatus,
}: Params) => {
	const hasFeedbackReview = useHasFeature("allow_impact_agent_feedback_review");

	const { data, loading, error } = useQuery(ListImpactAgentFeedbacks, {
		variables: {
			params: {
				impact_agent_id: impactAgentId,
				feedback_status: feedbackStatus,
			},
		},
		skip: !impactAgentId || !hasFeedbackReview,
		fetchPolicy: "cache-and-network",
	});

	return {
		feedbacks: getFragmentData(
			impactAgentFeedbackFieldsFragmentDoc,
			data?.listImpactAgentFeedbacks
		),
		loading,
		error,
	};
};
